import { Clock, MapPin, Phone, MessageCircle, Video, ExternalLink } from "lucide-react";
import { CLINIC, whatsappLink } from "@/constants/clinic";
import { useClinics } from "@/hooks/useClinics";

const ClinicCard = ({ c }) => (
  <div className="rounded-3xl bg-white/5 border border-white/10 p-6 flex flex-col" data-testid={`clinic-card-${c.id}`}>
    <span className="h-11 w-11 rounded-xl bg-white/10 grid place-items-center">{c.type === "online" ? <Video className="h-5 w-5" /> : <MapPin className="h-5 w-5" />}</span>
    <h3 className="mt-5 text-lg font-semibold">{c.name}</h3>
    <p className="mt-3 text-sm text-white/80 flex gap-2"><Clock className="h-4 w-4 mt-0.5 shrink-0 text-[#FACC15]" />{c.schedule}</p>
    <p className="mt-2 text-sm text-white/60 flex-1">{c.address || "Secure video consultation from home"}</p>
    {c.maps_url && (
      <a href={c.maps_url} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-[#FACC15] hover:underline" data-testid={`clinic-map-${c.id}`}>
        Open in Maps <ExternalLink className="h-3.5 w-3.5" />
      </a>
    )}
  </div>
);

export const ClinicInfo = () => {
  const clinics = useClinics();
  return (
    <section id="clinic" className="py-20 lg:py-28 bg-[#1E1B4B] text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-[#FACC15]">Available at</p>
            <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">Clinics & timings</h2>
          </div>
          <div className="flex flex-wrap gap-6 text-sm">
            <a href={`tel:+91${CLINIC.phone}`} className="flex items-center gap-2 hover:underline" data-testid="clinic-phone"><Phone className="h-4 w-4" /> Appointments: +91 {CLINIC.phone}</a>
            <a href={whatsappLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:underline" data-testid="clinic-whatsapp"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
          </div>
        </div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {clinics.map((c) => <ClinicCard key={c.id} c={c} />)}
        </div>
      </div>
    </section>
  );
};
